import { render, staticRenderFns } from "./AuditTrails.vue?vue&type=template&id=9078beec&"
import script from "./AuditTrails.vue?vue&type=script&lang=js&"
export * from "./AuditTrails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports